module.exports = __webpack_public_path__ + "assets/kosher-en-5dd7c5.svg";